module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-2-806d8db0e40a9203bb215b9c3b184f0d.jpg";